import React, { useEffect, useState } from "react";
import useHttp from "../../../hook/use-http";
import ChartLoader_Jupiter from "./ChartLoader_Jupiter";
import Table_Jupiter from "./Table_Jupiter";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitialstates_coral";
import "./TopFiveSectionTemplate_Jupiter.css";
import WaterMark from "../DashboardMain_Jupiter/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

function TopFiveSectionTemplate_Jupiter(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [tableData, setTableData] = useState([]);
  const [sortOrder, setSortOrder] = useState("desc");
  const { isLoading, sendReq: fetchData } = useHttp();

  let post_fix = IND === "RANGE" ? "Km" : "";

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  };

  function compareDesc(a, b) {
    return b.value - a.value;
  }

  function compareAsc(a, b) {
    return a.value - b.value;
  }

  const processData = (data, order) => {
    let result = data.map((obj) => {
      return {
        key: obj.key.vehicleId,
        value:
          // props.template_id === "collapseThree"
          //   ? obj.value.value
          //   : obj.Range.values["50.0"],
       
  IND === "ODO"
    ? obj.deltaOdo?.value
    : IND === "WHKM"
      ? obj.value.value
      : obj.Range.values["50.0"],
      };
    });

    result.sort(order === "asc" ? compareAsc : compareDesc);
    result = result.slice(0, 10);
    setTableData(result);
  };

    
 
  useEffect(() => {
    setSortOrder("desc");
    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/tabledata",
        body: { filterdata: gloablfilter, IND },
      },
      (data) => processData(data, "desc")
    );
  }, [gloablfilter]);

  const filterChanged = (event) => {
    const newOrder = event.target.value;
    setSortOrder(newOrder);

    fetchData(
      {
        url: API_URL_MAIN + "jupiter_drive_analysis/tabledata",
        body: { filterdata: gloablfilter, IND, soart: newOrder },
      },
      (data) => processData(data, newOrder)
    );
  };

  return (
    <>
      <div className="accordion-item">
        <h2 className="accordion-header" id={template_id + "Head"}>
          <div className="row" style={{ marginRight: "0px", marginLeft: "0px" }}>
            <div className="col-md-6 col-sm-6 col-6" style={{ padding: "0px" }}>
              <div className="acc_line" style={{ fontSize: "0.43em" }} align="left">
                <strong>&nbsp;{title}</strong>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-4" style={{ padding: "0px" }}>
              {soarting && (
                <select
                  onChange={filterChanged}
                  value={sortOrder}
                  className="form-select dropdownSelect acc_select"
                  aria-label="Default select example"
                >
                  <option value="desc">Top</option>
                  <option value="asc">Bottom</option>
                </select>
              )}
            </div>
            <div className="col-md-2 col-sm-2 col-2" style={{ padding: "0px" }}>
              {/* Accordion button if needed */}
            </div>
          </div>
        </h2>
        <div
          id={template_id}
          className={`accordion-collapse collapse ${show ? "show" : ""}`}
          aria-labelledby={template_id + "Head"}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body p-2">
            <WaterMark />
            {isLoading ? (
              <ChartLoader_Jupiter />
            ) : (
              <Table_Jupiter
                data={tableData}
                singleVinSelected={singleVinSelected}
                post_fix={post_fix}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default TopFiveSectionTemplate_Jupiter;
